module.exports = "/wp-content/plugins/farmacy/assets/js/images/strains-hybrid-f6d958692a39c852d5ef59ed01c9b93f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-thumb/img/strains-hybrid.png
 ** module id = 158
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 17 22 25 26
 **/